// Real Styne Group job photos only.

export const GALLERY_PROJECTS = [
  {
    id: "mount-evelyn-ensuite",
    title: "Master Ensuite Rebuild",
    suburb: "Mount Evelyn",
    category: "Bathrooms",
    scope: "Full strip-out, waterproofing, tiling, custom vanity, frameless shower",
    duration: "4 weeks",
    image: "https://customer-assets.emergentagent.com/job_engineered-site/artifacts/wzjuuqhu_IMG_3556.jpeg",
  },
  {
    id: "yarra-glen-drainage",
    title: "Stormwater Drainage Replacement",
    suburb: "Yarra Glen",
    category: "Civil & Drainage",
    scope: "Collapsed line diagnosis, excavation, new stormwater run, council sign-off",
    duration: "3 days",
    image: "https://customer-assets.emergentagent.com/job_engineered-site/artifacts/36ye4qvf_IMG_4564.jpeg",
  },
  {
    id: "croydon-hot-water",
    title: "Continuous Flow Gas Upgrade",
    suburb: "Croydon",
    category: "Hot Water",
    scope: "Old electric tank removed, wall-mounted continuous flow installed & commissioned",
    duration: "1 day",
    image: "https://customer-assets.emergentagent.com/job_engineered-site/artifacts/tb5rw2ug_IMG_6437.jpeg",
  },
  {
    id: "lilydale-emergency",
    title: "After-Hours Burst Main",
    suburb: "Lilydale",
    category: "Emergency",
    scope: "3am callout · isolated, replaced 8m of copper, restored supply before dawn",
    duration: "5 hours",
    image: "https://customer-assets.emergentagent.com/job_engineered-site/artifacts/32wjz2d2_IMG_3354.jpeg",
  },
];
